export const iconFontAwesomeSpinnersYinYang = (
	<i className="fa-solid fa-yin-yang"></i>
);
